import { FaInbox } from "react-icons/fa";

const Empty = () => {
  return (
    <section className="flex flex-col items-center justify-center py-[20px]">
      <FaInbox className="text-5xl text-light-text" />
      <p className="font-semibold text-light-text">No data...</p>
    </section>
  );
};

export default Empty;
